import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class RequestService {

  constructor() { }

  /**
   * @param funcao Observable<any> - Requisição a ser executada
   * @param confirm boolean - Perguntar se o usuário deseja realmente realizar a operação
   */
  async request(funcao: Observable<any>, confirm = false) {
    if (confirm) {
      await Swal.fire({
        title: 'Você tem certeza?',
        text: "Você não será capaz de reverter isso!",
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sim, continuar!'
      }).then((result) => {
        if (result.isConfirmed) {
          funcao.subscribe(res => {
            this.presentSuccess(res.success.text, res.success.duration);
          }, error => {
            this.presentError(error.error.error.text);
          });
        }
      });
    } else {
      funcao.subscribe(res => {
        this.presentSuccess(res.success.text, res.success.duration);
      }, error => {
        this.presentError(error.error.error.text);
      });
    }
  }

  private presentError(message: string) {
    Swal.fire({
      icon: 'error',
      title: 'Oops...',
      text: message
    });
  }

  private presentSuccess(message: string, duration?: number) {
    Swal.fire({
      position: 'center',
      icon: 'success',
      title: message,
      showConfirmButton: false,
      timer: duration ? duration : 1500
    });
  }

  handleBlobError(err: HttpErrorResponse): any {
    return new Promise<string>((resolve, reject) => {
      if ('application/json' === err.headers.get('Content-Type')) {
        const reader = new FileReader();
        reader.addEventListener('loadend', (e) => {
          resolve(JSON.parse(e.target.result.toString()))
        });
        reader.readAsText(err.error);
      } else {
        reject('not json')
      }
    })
  }
}
